/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPolicyExecution extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPolicyExecution");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPolicyExecution.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPolicyExecution>): BackgroundJobPayloadForPolicyExecution {
        let obj = Object.assign(new BackgroundJobPayloadForPolicyExecution(), model);
        BackgroundJobPayloadForPolicyExecution.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPolicyExecution>): BackgroundJobPayloadForPolicyExecution {
        if (!model) return null;
        return BackgroundJobPayloadForPolicyExecution.newInstance(<BackgroundJobPayloadForPolicyExecution> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPolicyExecution) {
        if (!obj) return;

        models.BackgroundJobPayloadForPolicyExecution.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPolicyExecution): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPolicyExecution.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    policy_job_id: string;

}
